var map = {
	"./apps/ai/manager/chainInstance/chainInstance.duck.js": 157,
	"./apps/combinedContextLoader/combinedContextLoader.duck.js": 121,
	"./apps/comments/commentsDisplay/commentsDisplay.duck.js": 918,
	"./apps/comments/listOfComments.duck.js": 625,
	"./apps/comments/singleComment/singleComment.duck.js": 626,
	"./apps/dashboard/actionlist/actionlist.duck.js": 229,
	"./apps/dashboard/dashboard.duck.js": 919,
	"./apps/dashboard/dashboardWidget/dashboardWidget.duck.js": 920,
	"./apps/dashboard/listofdocument/listofdocument.duck.js": 921,
	"./apps/dashboard/v2dashboardwidget/v2dashboardwidget.duck.js": 922,
	"./apps/projectManagement/addProjectModal/addProjectModal.duck.js": 230,
	"./apps/tour/tour.duck.js": 923,
	"./apps/workflow/headingWorkflow/headingWorkflow.duck.js": 132,
	"./apps/workflow/schemaBasedEditor/components/actionButtonArrayFieldTemplate/actionButtonArrayFieldTemplate.duck.js": 924,
	"./apps/workflow/schemaBasedEditor/components/arrayFieldTemplate/arrayFieldTemplate.duck.js": 925,
	"./apps/workflow/schemaBasedEditor/components/assigneeDropdown/assigneeDropdown.duck.js": 926,
	"./apps/workflow/schemaBasedEditor/components/checkboxWidget/checkboxWidget.duck.js": 927,
	"./apps/workflow/schemaBasedEditor/components/inputWidget/inputWidget.duck.js": 928,
	"./apps/workflow/schemaBasedEditor/components/primaryActionFieldTemplate/primaryActionFieldTemplate.duck.js": 929,
	"./apps/workflow/schemaBasedEditor/components/sectionTitle/sectionTitle.duck.js": 930,
	"./apps/workflow/schemaBasedEditor/components/selectWidget/selectWidget.duck.js": 931,
	"./apps/workflow/schemaBasedEditor/components/stageDropdown/stageDropdown.duck.js": 932,
	"./apps/workflow/schemaBasedEditor/components/topLevelArrayFieldTemplate/topLevelArrayFieldTemplate.duck.js": 933,
	"./apps/workflow/schemaBasedEditor/schemaBasedEditor.duck.js": 124,
	"./apps/workflow/workflowEditor/document/documentWorkflowEditor.duck.js": 123,
	"./apps/workflow/workflowEditor/heading/headingWorkflowEditor.duck.js": 99,
	"./apps/workflow/workflowWidget/components/adminWorkflowStatus/adminWorkflowStatus.duck.js": 934,
	"./apps/workflow/workflowWidget/components/approvalHistoryModal/approvalHistoryModal.duck.js": 227,
	"./apps/workflow/workflowWidget/components/approveModal/approveModal.duck.js": 935,
	"./apps/workflow/workflowWidget/components/assignableUsersSelect/assignableUsersSelect.duck.js": 936,
	"./apps/workflow/workflowWidget/components/assignedDocuments/assignedDocuments.duck.js": 937,
	"./apps/workflow/workflowWidget/components/authorAssignedBy/authorAssignedBy.duck.js": 938,
	"./apps/workflow/workflowWidget/components/authorCompleteBy/authorCompleteBy.duck.js": 939,
	"./apps/workflow/workflowWidget/components/executiveApproval/executiveApproval.duck.js": 940,
	"./apps/workflow/workflowWidget/components/executiveApproveBy/executiveApproveBy.duck.js": 941,
	"./apps/workflow/workflowWidget/components/executiveLastApproved/executiveLastApproved.duck.js": 942,
	"./apps/workflow/workflowWidget/components/nextDocumentButton/nextDocumentButton.duck.js": 943,
	"./apps/workflow/workflowWidget/components/progressButton/progressButton.duck.js": 944,
	"./apps/workflow/workflowWidget/components/widgetHeader/widgetHeader.duck.js": 945,
	"./apps/workflow/workflowWidget/components/workflowMessage/workflowMessage.duck.js": 946,
	"./apps/workflow/workflowWidget/components/workflowSettingsModal/workflowSettingsModal.duck.js": 947,
	"./apps/workflow/workflowWidget/components/workflowSettingsModalRow/workflowSettingsModalRow.duck.js": 948,
	"./apps/workflow/workflowWidget/components/workflowStatus/workflowStatus.duck.js": 949,
	"./apps/workflow/workflowWidget/workflowWidget.duck.js": 21,
	"./contexts/account/account.duck.js": 200,
	"./contexts/document/document.duck.js": 87,
	"./contexts/heading/heading.duck.js": 85,
	"./contexts/instance/instance.duck.js": 201,
	"./contexts/organisation/organisation.duck.js": 202,
	"./contexts/project/dataTypes/groups/groups.duck.js": 52,
	"./contexts/project/dataTypes/users/users.duck.js": 57,
	"./contexts/project/project.duck.js": 68,
	"./contexts/workflowinstance/workflowinstance.duck.js": 203,
	"./globals/darkTheme.duck.js": 950,
	"./globals/dataTypes/auth/auth.duck.js": 33,
	"./globals/dataTypes/comments/comments.duck.js": 45,
	"./globals/dataTypes/login/login.duck.js": 84,
	"./globals/dataTypes/maintenance/data/data.duck.js": 92,
	"./globals/dataTypes/notificationSettings/notificationSettings.duck.js": 110,
	"./globals/dataTypes/notifications/notifications.duck.js": 106,
	"./globals/dataTypes/performanceLogs/performanceLogs.duck.js": 182,
	"./globals/dataTypes/projects/projects.duck.js": 196,
	"./globals/dataTypes/workflow/workflowEditor/workflowEditor.duck.js": 69,
	"./globals/dataTypes/workflow/workflowTasks/workflowTasks.duck.js": 88,
	"./globals/global.duck.js": 163,
	"./parts/modalBehaviour/modalBehaviour.duck.js": 617,
	"./parts/showMoreBehaviour/showMoreBehaviour.duck.js": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 917;